<template>
  <q-table ref="tableRef"
           flat
           :loading="loading"
           :columns="columns"
           :rows="rows"
           :filter="search"
           @row-click="rowClick"
           v-model:pagination="pagination"
           @request="onRequest"
  >
    <template #body-cell-name="props">
      <q-td :props="props">
        <avatar size="24px" :project="props.row" class="q-mr-sm"/>
        {{ props.row.name }}
      </q-td>
    </template>

  </q-table>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from "vue"
import {Pagination} from "../models/common";
import {useRouter} from "vue-router"
import Avatar from "./Avatar.vue";
import {Organization} from "../models/organization";
import {useOrganizations} from "../composables/organization";

const props = defineProps<{
  type?: number,
  search: string
}>()

watch(() => props.type, () => {
  tableRef.value.requestServerInteraction()
})

const router = useRouter()
const tableRef = ref()
const loading = ref(false)


const columns = [
  {
    name: 'name',
    required: true,
    label: 'Организация',
    align: 'left',
    field: 'name',
    sortable: true
  },
  {name: 'owner', label: 'Создатель', field: (row: Organization) => row.owner?.username},
]

const pagination = ref({
  sortBy: 'desc',
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 10
})

const rows = ref<Organization[]>([])

async function onRequest(page: Pagination) {
  loading.value = true
  const {data} = await useOrganizations(page)
  rows.value = data.value?.content ?? []
  pagination.value.rowsNumber = data.value?.totalElements ?? 0
  loading.value = false
}

async function rowClick(evt: Event, row: any, index: number) {
  await router.push(`/organizations/${row.id}`)
}

onMounted(() => {
  fetch()
})

function fetch() {
  tableRef.value.requestServerInteraction()
}

defineExpose({
  fetch
})
</script>

<style scoped>

</style>